/**
 * Builds the nested Asset workspace URL under a record's Assets tab.
 */
export function getRecordScopedAssetWorkspacePath(input: {
	orgId: string;
	recordId: string;
	assetId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "form";
	return `/web/${input.orgId}/records/${input.recordId}/workspace/assets/${input.assetId}/workspace/${tab}`;
}

/**
 * Builds the Asset detail drawer URL for a record-scoped asset instance.
 */
export function getRecordScopedAssetDrawerDetailsPath(input: {
	orgId: string;
	recordId: string;
	assetId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "details";
	return `/web/${input.orgId}/records/${input.recordId}/workspace/assets/${input.assetId}/${tab}`;
}
